import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  Grid,
  Chip,
} from "@mui/material";
import { Doughnut } from "react-chartjs-2";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import applicant from "../profile/applicant.png"
import coapplicant from "../profile/coapplicant.png"
import End_Section_credit from "../components/End_section_credit"
 
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
 
ChartJS.register(ArcElement, Tooltip, Legend);
 
const Creditmemo = () => {
  const [collapsed, setCollapsed] = useState(true);
 
  // Dynamic score (0–5)
  const score = 4;
 
  // Labels + colors

  const labels = ["Very Low", "Low", "Medium", "High", "Very High"];
  const colors = ["#C7C7C7", "#C7C7C7", "#C7C7C7", "#5ABA85", "#034A7F"];
  // Gray out everything above "score"
  const backgroundColors = labels.map((_, index) =>
    index < score ? colors[index] : "#C7C7C7"
  );
 
  // Doughnut chart config
  const scoreData = {
    labels,
    datasets: [
      {
        data: [20, 20, 20, 20, 20], // equal segments
        backgroundColor: backgroundColors,
        borderColor: "#fff",
        borderWidth: 2,
        circumference: 180,
        rotation: -90,
        cutout: "70%",
      },
    ],
  };
 
  const scoreOptions = {
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
  };
 
  return (
    <Box sx={{ display: "flex", bgcolor: "#fff", minHeight: "100vh", fontFamily: '"Nunito Sans", "Roboto", "Arial", sans-serif' }}>
      {/* Sidebar */}
       <Sidebar collapsed={collapsed}   onToggleSidebar={() => setCollapsed(!collapsed)}/>
 
      {/* Main Content */}
      <Box sx={{   flex: 1,            //  grow/shrink properly
      minWidth: 0,        // avoids overflow when sidebar collapses
      display: "flex",
      flexDirection: "column",
      height: "100vh",     //  full height
      overflow: "hidden",  //  no scroll here either 
      }}>
        <Header
         
          collapsed={collapsed}
        />
 
        {/* Page Content */}
        <Box
           sx={{
             flexGrow: 1,
        width: "100%",
        p: { xs: 2, md: 3 },
        mt: { xs: 2, md: 5 },
        overflowY: "auto",  //  only this section scrolls
        overflowX: "hidden",
          }}
        >
          <Box sx={{ px: 2, width: "100%", maxWidth: "100%" }}>
            {/* Title */}
            <Typography variant="h5" fontWeight="bold" color="#034A7F" mt={2} gutterBottom>
              Raksha Solar House
            </Typography>
 
            {/* Three Card Responsive Grid */}
            <Grid container spacing={1.5} alignItems="stretch">
              {/* Applicant Card */}
              <Grid item xs={12} sm={6} md sx={{ flex: 1 }}>
                <Card sx={{ borderRadius: 3, boxShadow: 3, height: "100%" }}>
                  <CardContent sx={{ p: 2, pb: 1 }}>
                    <Typography gutterBottom color="#034A7F">Applicant</Typography>
                    <Avatar
                      src={applicant}
                      sx={{
                        width: { xs: 80, md: 100 },
                        height: { xs: 80, md: 100 },
                        mx: "auto",
                        mb: 2,
                      }}
                    />
                    <Typography textAlign="center" color="#034A7F">
                      Pramod Tiwari
                    </Typography>
                    <Typography
                      variant="body2"
                      textAlign="center"
                      color="#C7C7C7"
                    >
                      +91 9300806020
                    </Typography>
                    <Typography variant="body2" mt={1} textAlign="center" color="#034A7F">
                      Quantum of Loan: ₹10,00,000
                    </Typography>
                    <Box sx={{ textAlign: "center" }}>
                      <Chip
                        label="MSME for SME Business"
                        size="small"
                        sx={{
                          mt: 3,
                          bgcolor: "#C7C7C7",
                          color: "#034A7F",
                          fontSize: "0.75rem",
                        }}
                      />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
 
              {/* Overall Score */}
              <Grid item xs={12} sm={6} md sx={{ flex: 1 }}>
                <Card sx={{ borderRadius: 3, boxShadow: 3, height: "100%" }}>
                  <CardContent sx={{ p: 2, pb: 1 }}>
                    <Typography gutterBottom color="#034A7F">Overall Score</Typography>
                    <Box
                      sx={{
                        position: "relative",
                        width: { xs: "150px", md: "180px" },
                        height: { xs: "150px", md: "180px" },
                        mx: "auto",
                      }}
                    >
                      <Doughnut data={scoreData} options={scoreOptions} />
                      <Box
                        sx={{
                          position: "absolute",
                          top: "55%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          fontWeight: "bold",
                          marginTop: 2,
                          marginBottom: 0,
                        }}
                      >
                        <Typography variant="h5" fontWeight="bold" color="#034A7F">
                          {score}/5
                        </Typography>
                      </Box>
                    </Box>
                    <Box textAlign="center" mt={-1}>
                      <Typography variant="body2" color="#C7C7C7">
                        Sign Board Visibility
                      </Typography>
                      <Typography variant="body2" color="#C7C7C7">
                        Machines
                      </Typography>
                      <Typography variant="body2" color="#C7C7C7">
                        Inventory Value
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
 
              {/* Co-Applicant Card */}
              <Grid item xs={12} md={8}>
                <Card sx={{ borderRadius: 3, boxShadow: 3, height: "100%" }}>
                  <CardContent sx={{ p: 2, pb: 1 }}>
                    <Grid container spacing={2}>
                      {/* Left: Profile */}
                      <Grid item xs={12} sm={4}>
                        {/* <Typography gutterBottom>Co-Applicant</Typography> */}
                        <Avatar
                          src={coapplicant}
                          variant="square"
                          sx={{
                            width: { xs: 120, md: 140 },
                            height: { xs: 80, md: 100 },
                            mx: "auto",
                            mb: 1,
                            borderRadius: 2,
                            objectFit: "cover",
                          }}
                        />
                        {/* <Typography fontWeight="bold">Suman Tiwari</Typography>
                        <Typography variant="body2">+91 9300806020</Typography>
                        <Typography variant="body2">PAN - AFBPT5811L</Typography>
                        <Typography variant="body2">
                          32 Yrs, Business Owner
                        </Typography>
                        <Typography variant="body2">
                          Address: Bhopal, MP
                        </Typography> */}
                      </Grid>
 
                      {/* Right: Loan details */}
                      <Grid item xs={12} sm={8}>
                        <Grid container spacing={3}>
                          {/* Left Column */}
                          <Grid item xs={6}>
                            <Box mb={2}>
                              <Typography variant="body2" color="#034A7F">
                                Loan Application ID
                              </Typography>
                              <Typography color="#C7C7C7">DFS/015/2024</Typography>
                            </Box>
 
                            <Box mb={2}>
                              <Typography variant="body2" color="#034A7F">
                                Type of Loan
                              </Typography>
                              <Typography color="#C7C7C7">Dealer Finance</Typography>
                            </Box>
 
                            <Box mb={2}>
                              <Typography variant="body2" color="#034A7F">
                                Disbursal to Name
                              </Typography>
                              <Typography color="#C7C7C7">Waaree Energies Ltd.</Typography>
                            </Box>
 
                            <Box mb={2}>
                              <Typography variant="body2" color="#034A7F">
                                Term of Facility
                              </Typography>
                              <Typography color="#C7C7C7">12 Months</Typography>
                            </Box>
                          </Grid>
 
                          {/* Right Column */}
                          <Grid item xs={6}>
                            <Box mb={2}>
                              <Typography variant="body2" color="#034A7F">
                                Loan Application Date
                              </Typography>
                              <Typography color="#C7C7C7">25-09-2024</Typography>
                            </Box>
 
                            <Box mb={2}>
                              <Typography variant="body2" color="#034A7F">
                                Facility Amount
                              </Typography>
                              <Typography color="#C7C7C7">₹20,00,000</Typography>
                            </Box>
 
                            <Box mb={2}>
                              <Typography variant="body2" color="#034A7F">
                                Tenure of Each Tranch
                              </Typography>
                              <Typography color="#C7C7C7">90 Days</Typography>
                            </Box>
 
                            <Box mb={2}>
                              <Typography variant="body2" color="#034A7F">
                                Disbursal to Account
                              </Typography>
                              <Typography color="#C7C7C7">32057965308 (SBI)</Typography>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Box>
          <End_Section_credit/>
          
        </Box>
        
      
      </Box>
    </Box>
  );
};
 
export default Creditmemo;